import { http } from 'config';

export const callNextPage = (api, resolve = (data) => data, reject = (e) => e, prevData) => {
  return http
    .get(api)
    .then((response) => {
      const dataKey = response.data.results || response.data.features;
      const data = prevData ? [...prevData, ...dataKey] : [...dataKey];
      if (response.data.next) return callNextPage(response.data.next, resolve, reject, data);
      return resolve(data);
    })
    .catch(reject);
};

export const callNextPageRes = (api, resolve = (data) => data, reject = (e) => e, prevData) => {
  return http
    .get(api)
    .then((response) => {
      const dataKey = response.data.results || response.data.features;
      const data = prevData ? [...prevData, ...dataKey] : [...dataKey];
      if (response.data.next) return callNextPageRes(response.data.next, resolve, reject, data);
      return { res: response, resolvedData: resolve(data) };
    })
    .catch(reject);
};
